import {
  SET_NEW_ZAPIER,
  SET_LEGACY_ZAPIER,
  DISABLE_LEGACY_ZAPIER,
  UPDATE_ZAPIER_DATA,
} from "../actions/types";

const LEGACY_CONNECTOR = {
  enabled: false,
  data:{}
};

const NEW_CONNECTOR = {
  enabled: false,
  data: {
    is_active:false
  },
};

const initialState = {
  legacy_zapier: LEGACY_CONNECTOR,
  new_zapier: NEW_CONNECTOR,
};
/**
 * Saves all users and groups associated with the UG
 * @param {Object} state Default empty state
 * @param {Object} action Action dispached from AC
 */
export const ugConnectorReducer = (state = initialState, action) => { //NOSONAR
  switch (action.type) {
    case UPDATE_ZAPIER_DATA: {
      return { ...state, ...action.payload };
    }

    case DISABLE_LEGACY_ZAPIER: {
      return { ...state, legacy_zapier: LEGACY_CONNECTOR };
    }

    case SET_LEGACY_ZAPIER: {
      return {
        ...state,
        legacy_zapier: action.payload,
      };
    }

    case SET_NEW_ZAPIER: {
      return {
        ...state,
        new_zapier: { ...state.new_zapier, data: action.payload },
      };
    }

    default:
      return state;
  }
};
